import type { FC } from 'react';
import { useMatch } from 'react-router-dom';
import type { ResourceBlock } from '@domain/schemas/contract.schema';
import type { Team } from '@domain/schemas/team.schema';
import type { AuditEntry } from '@domain/types/audit-log';
import Nav from '@src/routes';

import { buildSummaryContext, getSummaryRenderer } from './summaries';

interface ChangeSummaryProps {
  blocks: ResourceBlock[];
  sections: { id: string; label: string }[];
  teams: Team[];
  item: AuditEntry;
}

export const ChangeSummary: FC<ChangeSummaryProps> = ({ blocks, sections, teams, item: entry }) => {
  const isEndorsementSummaryView = !!useMatch(Nav.EndorsementView);
  const renderer = getSummaryRenderer(entry.action);
  if (!renderer) return null;
  return renderer({ entry, ctx: buildSummaryContext(entry, { blocks, sections, teams, isEndorsementSummaryView }) });
};
